import styles from "./LandscapeOverly.module.css";
import herno from "./../../static/images/logoCondensed.svg";
import { Text, Image } from "rebass";
const LandscapeOverly = ({ text }) => {
  return (
    <div className={styles.LandscapeOverly}>
      <div className={styles.LandscapeOverlyBoxTextImage}>
        <Image src={herno} width={100} height={100} />
        <Text color={"white"} fontSize={18} margin={20} fontWeight={700}>
          {text}
        </Text>
      </div>
    </div>
  );
};

export default LandscapeOverly;
